import { useSuspenseQuery } from '@tanstack/react-query';

import api from 'src/axios';
import forecastService from 'src/services/forecast/forecastService';

export type SkuDetailData = {
  sku: string;
  internal_title: string;
  product_first_stock_entry_at_date_key: string;
  life_segment_label: string;
  last_reviewed_date: string;
  rotation_segment_sales: {
    value: string;
    label: string;
  };
  rotation_segment_forecast: {
    value: string;
    label: string;
  };
  product_started_at_date_key: string;
  is_novelty: boolean;
  is_destocking: boolean;
};

export function useSkuDetailQuery(sku: string) {
  return useSuspenseQuery<SkuDetailData>({
    queryKey: ['skuDetail', sku],
    queryFn: async () => {
      const { data } = await api.get(`/products/${sku}`);
      return forecastService.formatSkuDetail(data);
    },
  });
}
